import React, { useEffect, Component, useState, useRef } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { useHistory, Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ApiService } from '../../containers/Services/apiservice';
import { Watch } from "react-loader-spinner";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

let apiServices = new ApiService();
const MutualFunds = () => {
  let history = useHistory();
  const { type } = useParams();
  const [mutualFundData, setMutualFundData] = useState([]);
  const [MutualFundAmcData, setMutualFundAmcData] = useState([]);
  const [MutualFundCatData, setMutualFundCatData] = useState([]);
  const [MutualFundSubCatData, setMutualFundSubCatData] = useState([]);
  const [MutualFundDividendData, setMutualFundDividendData] = useState([]);
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [selcatcode, setselcatcode] = useState('');
  const [SubCat, setSubCat] = useState(0);
  const [Fundcode, setFundcode] = useState(0);
  const [AlertColor, setAlertColor] = useState('alert alert-info tx-14 d-flex align-items-center');
  const [ePayEezzStatus, SetePayEezzStatus] = useState('');
  const [linkurl, setlinkurl] = useState('#');
  const [UserBankData, SetUserBankData] = useState({});
  const [userid, SetUserid] = useState();
  const [show, setShow] = useState(false);
  const [Clickhere, setClickhere] = useState(0);
  const [canstatusmsg, setCanStatus] = useState('');
  const [bankApprove, setBankApproved] = useState('')
  const [canRegister, setCanRegister] = useState('')
  const [CanId, setCanId] = useState('');
  const [EpayezzReg, setEpayezzReg] = useState(0); const didMountRef = useRef(true);
  const [mfName, setMfName] = useState('')
  const [mfId, setMfId] = useState('')
  const [amcName, setAmcName] = useState([])
  const [nameChange, setNameChange] = useState([])
  const [MutualFundFilter, setMutualFundFilter] = useState({ amc: '', category: '', subcategory: '' })
  const [amcId, setAmcId] = useState('')
  const [catId, setCatId] = useState('1')
  const [dividentId, setDividentId] = useState('')
  const [mutualFilterName, setMutualFilterName] = useState('')
  const [amcFilterName, setAmcFilterName] = useState('')
  const [categoryFilter, setCategoryFilter] = useState("EQUITY")
  const [dividentFilterName, setDividentFilterName] = useState('')
 useEffect(() => {
    if (didMountRef.current) {
      getsubcategory(catId, categoryFilter)
      localStorage.removeItem("MYFILTER");
      localStorage.removeItem("AMC");
      localStorage.removeItem("SUBCAT");
      localStorage.setItem("CATEGORY", '1')
      applyfilter();
      // if (localStorage.getItem("MYFILTER") && JSON.parse(localStorage.getItem("MYFILTER")) != null) {
      //   setAmcName(JSON.parse(localStorage.getItem("MYFILTER")));

      // }
      apiServices.datarecommendedGetRequest().then(res => {
        console.log(res)
        if (res.data.status == 'success') {
          setMutualFundData(res.data.data)
        }
        else if (res.data.status == "error" && res.data.message == "Session expired") {
          localStorage.removeItem('AUTH_TOKEN');
          // alert(res.data.message)
          setSpinnerLoading(false)
          history.push("/login")
        }
        else {
          alert(res.data.message)
          setSpinnerLoading(false)
        }
      })
      const dataString = {
      }
      apiServices.getUserData(dataString).then(result => {
        console.log(result)
        if (result.data.status == 'success') {
          var res = result.data.data;
          setCanId(res.gs_can_id);
          setBankApproved(res.gs_epayezz_bankapprove)
          setCanRegister(res.gs_can_register)
          if (res.gs_risk_assestment_status == 1) {
            setEpayezzReg(res.gs_epayezz_reg)
          }
        }
        else if (result.data.status == "error" && result.data.message == "Session expired") {
          localStorage.removeItem('AUTH_TOKEN');
          // alert(result.data.message)
          setSpinnerLoading(false)
          history.push("/login")
        }
        else {
          alert(result.data.message)
          setSpinnerLoading(false)
          return false
        }
      })
      // canstatus();
      getusrbanks();
      getmutualfundamc();
      getmutualfundcategory();
      getmutualfunddividend();
    }
    didMountRef.current = false;
  });
  const removesubcatfilter = () => {
    setMutualFilterName('')
    localStorage.removeItem("SUBCAT");
    applyfilter()
  }
  const removecatfilter = () => {
    setCategoryFilter('EQUITY');
    setCatId('1');
    localStorage.setItem("CATEGORY", '1')
    applyfilter()
  }
  const removeamcfilter = () => {
    setAmcFilterName('')
    localStorage.removeItem("AMC");
    applyfilter()
  }
  const getusrbanks = () => {
    const dataString = {
    }
    apiServices.getusercanbankdata(dataString).then(res => {
      if (res.data.status == 'success') {
        SetUserBankData(res.data.data)
      }
      else if (res.data.status == "error" && res.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(res.data.message)
        setSpinnerLoading(false)
        return false
      }
    }
    )
  }
  const getmutualfundamc = () => {
    setSpinnerLoading(true)
    apiServices.getmutualfundamc().then(res => {
      console.log(res)
      if (res.data.status == 'success') {
        setMutualFundAmcData(res.data.data);
        setSpinnerLoading(false);
      }
      else if (res.data.status == "error" && res.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(res.data.message)
        setSpinnerLoading(false)
        return false
      }
    })
  }
  const getmutualfundcategory = () => {
    setSpinnerLoading(true)
    apiServices.getmutualfundcategory().then(res => {
      console.log(res)
      if (res.data.status == 'success') {
        setMutualFundCatData(res.data.data);
        setSpinnerLoading(false);
      }
      else if (res.data.status == "error" && res.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(res.data.message)
        setSpinnerLoading(false)
        return false
      }
    })
  }
  const getmutualfunddividend = () => {
    setSpinnerLoading(true)
    apiServices.getmutualfunddividend().then(res => {
      console.log(res)
      if (res.data.status == 'success') {
        setMutualFundDividendData(res.data.data);
        setSpinnerLoading(false);
      }
      else if (res.data.status == "error" && res.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(res.data.message)
        setSpinnerLoading(false)
        return false
      }
    })
  }
  const getsubcategory = (catid, name) => {
    setSpinnerLoading(true)
    const dataString = {
      "catid": catid,
    }
    apiServices.getmutualfundsubcategory(dataString).then(res => {
      console.log(res)
      if (res.data.status == 'success') {
        setselcatcode(catid);
        setMutualFundSubCatData(res.data.data);
        setSpinnerLoading(false);
      }
      else if (res.data.status == "error" && res.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(res.data.message)
        setSpinnerLoading(false)
        return false
      }
    })
      .catch(error => {
      })
  }
  const mutualfunddataamultifiler = (subcat, name) => {
    localStorage.setItem("SUBCAT", subcat)
    setSubCat(subcat);
    setMutualFilterName(name)
    applyfilter()
    return false;
  }
  const dividenttypedata = (id, name) => {
    localStorage.setItem("DIVIDENT", id);
    setDividentId(id)
    setDividentFilterName(name)
    applyfilter();
    //  let dividentname = [];
    // if (localStorage.getItem("MYFILTER") && localStorage.getItem("MYFILTER") != null) {
    //   if (dividentname.length > 0 && dividentname.includes(name)) {
    //  }
    //   else {
    //     dividentname = JSON.parse(localStorage.getItem("MYFILTER"));
    //     dividentname.push(name)
    //     }
    // }
    // else {
    //   dividentname.push(name)
    // }
    // localStorage.setItem("MYFILTER", JSON.stringify(dividentname))
    // setAmcName(JSON.parse(localStorage.getItem("MYFILTER")));
  }
  const categorynamedata = (id, name) => {
    localStorage.setItem("CATEGORY", id);
    setCatId(id)
    setCategoryFilter(name)
    getsubcategory(id, name)
    applyfilter();
  }
  const applyfilter = () => {
    console.log(localStorage.getItem("AMC"))
    console.log(localStorage.getItem("CATEGORY"))
    console.log(localStorage.getItem("SUBCAT"))
    // console.log(localStorage.getItem("DIVIDENT"))
    const dataString = {
      "amc": localStorage.getItem("AMC"),
      "category": localStorage.getItem("CATEGORY"),
      "subcat": localStorage.getItem("SUBCAT"),
      // "divident": dividentId,
      "type": type
    }
    apiServices.mutualFundGetRequest(dataString).then(res => {
      console.log(res)
      if (res.data.status == 'success') {
        // setSubCat(subcat);
        setMutualFundData(res.data.data);
        setSpinnerLoading(false);
      }
      else if (res.data.status == "error" && res.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(res.data.message)
        setSpinnerLoading(false)
        return false
      }
    })
  }
  const mutualfunddataa = (fundcode, name) => {
    localStorage.setItem("AMC", fundcode);
    setAmcFilterName(name)
    setAmcId(fundcode)
    setAmcFilterName(name)
    // setMutualFundFilter({ ...MutualFundFilter, ['amc']: fundcode })
    applyfilter();
    // setTimeout(() => {
    //   console.log(MutualFundFilter);
    // }, 3000);
    return false;
    //  if (localStorage.getItem("MYFILTER") && localStorage.getItem("MYFILTER") != null) {
    //     if (amcnames.length > 0 && amcnames.includes(name)) {
    //    }
    //     else {
    //       amcnames = JSON.parse(localStorage.getItem("MYFILTER"));
    //       amcnames.push(name)
    //    }
    //   }
    //   else {
    //     amcnames.push(name)
    //   }
    //  localStorage.setItem("MYFILTER", JSON.stringify(amcnames));
    //   setAmcName(JSON.parse(localStorage.getItem("MYFILTER")));
    //  setFundcode(fundcode);
    setSpinnerLoading(true)
    const dataString = {
      "fundcode": fundcode,
      "type": type
    }
    apiServices.mutualFundGetRequest(dataString).then(res => {
      console.log(res)
      if (res.data.status == 'success') {
        setMutualFundData(res.data.data);
        setSpinnerLoading(false);
      }
    })
  }
  //   const removeitem = (name) => {
  //   let amcremove = JSON.parse(localStorage.getItem("MYFILTER"));
  // if (amcremove.length > 0 && amcremove.includes(name)) {
  //   // amcremove = JSON.parse(localStorage.getItem("MFFILTER"));
  //     amcremove.push(amcremove.splice(amcremove.indexOf(name), 1)[0])
  //     amcremove.pop()
  // }
  //   localStorage.setItem("MYFILTER", JSON.stringify(amcremove));
  //   setAmcName(JSON.parse(localStorage.getItem("MYFILTER")));
  // }
  const resetitem = () => {
    setAmcFilterName('')
    localStorage.removeItem("AMC");
    setCategoryFilter('EQUITY');
    localStorage.setItem("CATEGORY", '1')
    setMutualFilterName('')
    localStorage.removeItem("SUBCAT");
    applyfilter();
  }
  const onetime = (id) => {
    setShow(false)
    history.push('/mfdetail/' + id)
  }
  const sip = (id) => {
    setShow(false)
    let sipselected = [];
    sipselected.push(id)
    localStorage.setItem("SELMFS", JSON.stringify(sipselected));
    history.push('/mfsipdetail/0')
  }
  const model = (name, id) => {
   setShow(true)
    setMfName(name)
    setMfId(id)
  }
  const creategoal = () => {
    setShow(false)
    history.push('/goalsettings/')
  }
  const handleClose = () => setShow(false);
  return (
    <div>
      <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
        <div className='overlay-box'>
          <Watch
            color="#ffffff"
            visible={spinnerLoading}
          />
        </div>
      </div>
      <Header />
      <Helmet></Helmet>
      <title>MutualFunds - Goalstox</title>
      <section className='section-small'>
        <div className="container-fluid">
          <div className='row'>
            <div className='col-lg-3'>
              <div className='mfsidebar'>
                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        AMC
                      </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                      <div className="accordion-body" style={{ height: '250px', overflowY: 'auto' }}>
                        <ul>
                          {
                            MutualFundAmcData.length > 0 ?
                              MutualFundAmcData.map(key =>
                                <>
                                  <li className={key.amc_fundcode === amcId ? "active" : ""} onClick={() => mutualfunddataa(key.amc_fundcode, key.amc_name)}>{key.amc_name}</li>
                                </>
                              )
                              : ''
                          }
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        Category
                      </button>
                    </h2>
                    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                      <div className="accordion-body">
                        <ul>
                          {
                            MutualFundCatData.length > 0 ?
                              MutualFundCatData.map(key =>
                                <>
                                  {/* <li onClick={() => mutualfunddataa(key.amc_fundcode)}>{key.amc_name}</li> */}
                                  <li className={key.cat_code === catId ? "actve" : ""} onClick={() => categorynamedata(key.cat_code, key.cat_name)}>{key.cat_name}</li>
                                </>
                              )
                              : ''
                            }
                        </ul>
                      </div>
                    </div>
                  </div>
                  {/* <div className="accordion-item">
                    <h2 className="accordion-header" id="headingThree">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        Divident Type
                      </button>
                    </h2>
                    <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                      <div className="accordion-body">
                        <ul>
                          {
                            MutualFundDividendData.length > 0 ?
                              MutualFundDividendData.map(key =>
                                <>
                                  <li className={key.div_id===dividentId ?"active":""} onClick={() => dividenttypedata(key.div_id , key.div_name)}>{key.div_name}</li>
                                </>
                              )
                              : ''
                          }
                        </ul>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="accordion-item">
<h2 className="accordion-header" id="headingFour">
<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
Min. Purchase Amount
</button>
</h2>
<div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
<div className="accordion-body">
</div>
</div>
</div> */}
                </div>
              </div>
            </div>
            <div className='col-lg-9'>
              <h4 className="tx-18 mg-b-5">Categories</h4>
              <p>Select fund categories for you to start investing</p>
              <div className='tabcat mg-b-20'>
                {
                  MutualFundCatData.length > 0 ?
                    MutualFundCatData.map(key =>
                      <>
                        {/* <li onClick={() => mutualfunddataa(key.amc_fundcode)}>{key.amc_name}</li> */}
                        <span className={key.cat_code === catId ? 'active' : ''} onClick={() => categorynamedata(key.cat_code, key.cat_name)} style={{ cursor: "pointer" }}>{key.cat_name}</span>
                      </>
                    )
                    : ''
                }
                {/*<span id="equity" className='active'></span>
<span id="debt" > Debt</span> */}
              </div>
              {MutualFundSubCatData.length > 0 ?
                <div className='tabcat-content mg-b-20'>
                  <div className='tabcatlist'>
                    <ul>
                      {
                        MutualFundSubCatData.length > 0 ?
                          MutualFundSubCatData.map(key =>
                            <>
                              {/* <li onClick={() => mutualfunddataa(key.amc_fundcode)}>{key.amc_name}</li> */}
                              <li className={key.subcat_code === SubCat && key.subcat_cat_code === selcatcode ? 'active' : ''} onClick={() => mutualfunddataamultifiler(key.subcat_code, key.subcat_desc)}>{key.subcat_desc}</li>
                            </>
                          )
                          : ""
                      }
                      {/* <div className="row justify-content-md-center">
<div className='col-lg-8 tx-center'>
<p>Thanks for setting up your profile and financial goals.. we have saved your requirements and will get in touch with you shortly for investments</p>
<div className="theme-button"><a className="btn" href="/dashboard">Continue</a></div>
</div>
</div> */}

                    </ul>
                  </div>
                </div> : ''
              }
              {/*================================*/}
              <div className='mg-b-20'>
                <h4 class="tx-18 mg-b-5">Filters</h4>
                <div className='filterselect'>
                  <div className='filterselectlist'>
                    <ul>
                      {amcFilterName ? <li>{amcFilterName}<i onClick={removeamcfilter} class="fa fa-times" aria-hidden="true"></i></li> : ""}
                      {categoryFilter ? <li>{categoryFilter}<i onClick={removecatfilter} class="fa fa-times" aria-hidden="true"></i></li> : ""}
                      {mutualFilterName ? <li>{mutualFilterName}<i onClick={removesubcatfilter} class="fa fa-times" aria-hidden="true"></i></li> : ""}
                      {dividentFilterName ? <li>{dividentFilterName}<i class="fa fa-times" aria-hidden="true"></i></li> : ""}
                      {/* <li> {key} <i class="fa fa-times" aria-hidden="true" onClick={(e) => { removeitem(key) }}></i></li> */}
                   </ul>
                  </div>
                  <button className='resetbutton' onClick={resetitem}>Reset Filter</button>
                </div>
              </div>
              {/*================================*/}
              <div className='fundlist'>
                <ul>
                  {
                    mutualFundData.length > 0 && type == 'sip' ?
                      mutualFundData.map((key) =>

                        <li onClick={(e) => { sip(key.mf_id) }}>
                          <div style={{ cursor: "pointer" }}>
                            <h6 className='mg-b-5'>{key.plan_name}</h6>
                            <p className='mg-b-0 tx-12'>{key.scheme_code}</p>
                          </div>
                        </li>
                      )
                      : ''}
                  {
                    mutualFundData.length > 0 && type == 'purchase' ?
                      mutualFundData.map((key) =>

                        <li onClick={(e) => { onetime(key.mf_id) }}>
                          <div style={{ cursor: "pointer" }}>
                            <h6 className='mg-b-5'>{key.plan_name}</h6>
                            <p className='mg-b-0 tx-12'>{key.scheme_code}</p>
                          </div>
                        </li>
                      )
                      : ''}
                  {mutualFundData.length > 0 && (type == '' || type == undefined) ?
                    mutualFundData.map(key =>
                      <li onClick={(e) => { model(key.plan_name, key.mf_id) }}>
                        <div style={{ cursor: "pointer" }}>
                          <h6 className='mg-b-5'>{key.plan_name} </h6>
                          <p className='mg-b-0 tx-12'>{key.scheme_code}</p>
                        </div>
                      </li>
                    ) : <li>
                      <div>
                        <h5 className='mg-b-5'>NO FUNDS FOUND !!</h5>
                      </div>
                    </li>
                  }
                  <Modal show={show}>
                    <Modal.Header closeButton onClick={handleClose}>
                      <Modal.Title ><h6>{mfName}</h6></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {canRegister == 0
                        ? <p>Your CAN is not approved yet</p>
                        : ""}
                      {canRegister == 1
                        ? <Button variant="secondary" onClick={(e) => { onetime(mfId) }} style={{ width: "100%" }}>One time Invest</Button> : ""}
                      {bankApprove == 1 && canRegister == 1
                        ? <><Button variant="primary" className="btn btn-default mg-t-20" onClick={(e) => { sip(mfId) }} style={{ width: "100%" }} >Start SIP</Button>
                          <Button variant="primary" className="btn btn-default mg-t-20" onClick={(e) => { creategoal() }} style={{ width: "100%" }} >Create Goals and Invest</Button>
                        </> : ""}
                      {bankApprove == 0 && canRegister == 1
                        ? <><Link to="/mferror" variant="primary" className="btn btn-default mg-t-20" style={{ width: "100%" }} >Start SIP</Link>
                          <Link to="/mferror" variant="primary" className="btn btn-default mg-t-20" style={{ width: "100%" }} >Create Goals and Invest</Link>
                        </> : ""}
                    </Modal.Body>
                  </Modal>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
export default MutualFunds;